module.exports = {
    "wizard": "mc12c16a24_wizard",
    "section": "mc12c16a24_section",
    "title": "mc12c16a24_title",
    "success": "mc12c16a24_success",
    "content": "mc12c16a24_content",
    "active": "mc12c16a24_active",
    "bullet": "mc12c16a24_bullet"
};